export default __webpack_public_path__ + "media/bundles/App/layout/icon/svgs/chevron-right-6b08103b1ade4bf6ed6d69d3e45bf2a4.svg";